module.exports = __webpack_public_path__ + "img/UNIONPAY2x.png?f57c0399df6ca2bb23fef4f8a12ca1ab";